import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../context/AuthContext";
import { requestTelegramReauth } from "../utils/authSession";

const RequireAuth = () => {
    const { token, authStatus } = useAuth();
    const location = useLocation();

    if (authStatus === "loading") {
        return null;
    }

    if (!token) {
        if (requestTelegramReauth("protected-route")) {
            return <Navigate to="/" replace />;
        }

        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return <Outlet />;
};

export default RequireAuth;